import { render } from "./MailConfiguration.vue?vue&type=template&id=27d8fbf6&scoped=true"
import script from "./MailConfiguration.vue?vue&type=script&lang=js"
export * from "./MailConfiguration.vue?vue&type=script&lang=js"

import "./MailConfiguration.vue?vue&type=style&index=0&id=27d8fbf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d8fbf6"]])

export default __exports__